import { ChartOptions } from 'chart.js';
import { ReactNode } from 'react';

type WaysToEarnList = Array<{ number: number; description: string | ReactNode }>;

export const wayToEarnListOne: WaysToEarnList = [
    {
        number: 1,
        description: 'Выбери номер для друга или члена семьи',
    },
    {
        number: 2,
        description: 'Оплати удобным способом',
    },
    {
        number: 3,
        description: (
            <span>
                Получай по 100 Б каждый месяц, пока друг оплачивает тариф
                <br />
                (1 Б = 1 руб.)
            </span>
        ),
    },
    {
        number: 4,
        description: 'Оплачивай бонусами свою сотовую связь',
    },
];

export const wayToEarnListTwo: WaysToEarnList = [
    {
        number: 1,
        description: 'Пригласи друга зарегистрироваться в Другомании',
    },
    {
        number: 2,
        description: 'Дождись, пока он продаст номер своим друзьям',
    },
    {
        number: 3,
        description: 'Получай ежемесячно 2% от его дохода',
    },
    {
        number: 4,
        description: 'Оплачивай бонусами свою сотовую связь',
    },
];

export const waysToEarnAuth: WaysToEarnList = [
    {
        number: 1,
        description: 'Выбери номер для друга',
    },
    {
        number: 2,
        description: 'Зарабатывай по 100 Б ежемесячно за каждый активный номер',
    },
    {
        number: 3,
        description: 'Получай вечную скидку на свою сотовую связь',
    },
];

export const options: ChartOptions<'bar'> = {
    elements: {
        bar: {
            borderWidth: 1,
            borderColor: 'transparent',
        },
    },
    maintainAspectRatio: false,
    plugins: {
        title: {
            // enabled: false,
            display: false,
        },
        tooltip: {
            enabled: false,
        },
        legend: {
            display: false,
        },
    },

    responsive: true,
    scales: {
        // ticks: {
        //   display: true,
        // },
        x: {
            display: true,
            border: {
                display: false,
            },
            stacked: true,
            grid: {
                display: false,
            },
            ticks: {
                padding: -2,
            },
        },
        y: {
            display: false,
            border: {
                display: false,
            },
            stacked: true,
            grid: {
                display: false,
            },
        },
    },
};

export const BORDER_RADIUS = 4;

export const placeholderChartData = [
    [30, 40, 50, 30, 30, 40],
    [null, null, 30, 30, 40, 30],
    [null, 40, 70, 90, 100, 120],
    [null, null, null, null, null, null],
];
